// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondary{
    background-color: #969da3;
    margin-top: 5px;
    padding: 4px 10px;
}

.tsCentered{
    vertical-align: middle;
}

.btn-accion{
    margin: 3px;
    font-size: x-small;
}

.selected{
    background-color: rgba(173, 216, 230, 0.6)!important;
}
.programa {
    cursor: pointer;
}
.programa:hover{
    background-color: rgba(173, 216, 230, 0.4);
}



.scrollable {
    max-height: 50vh; /* Ajusta esta altura según tus necesidades */
    overflow-y: scroll;
}
.scrollable::-webkit-scrollbar {
    width: 8px; /* Ancho del scroll */
}
.scrollable::-webkit-scrollbar-thumb {
    background-color: rgba(100, 100, 100, 0.5); /* Color del scroll */
    border-radius: 10px; /* Redondeo del scroll */
}
.scrollable::-webkit-scrollbar-thumb:hover {
    background-color: rgba(100, 100, 100, 0.7); /* Color al pasar el cursor */
}
.scrollable::-webkit-scrollbar-track {
    background: transparent; /* Fondo del track del scroll */
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/clientes/clientes.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oDAAoD;AACxD;AACA;IACI,eAAe;AACnB;AACA;IACI,0CAA0C;AAC9C;;;;AAIA;IACI,gBAAgB,EAAE,6CAA6C;IAC/D,kBAAkB;AACtB;AACA;IACI,UAAU,EAAE,qBAAqB;AACrC;AACA;IACI,0CAA0C,EAAE,qBAAqB;IACjE,mBAAmB,EAAE,wBAAwB;AACjD;AACA;IACI,0CAA0C,EAAE,6BAA6B;AAC7E;AACA;IACI,uBAAuB,EAAE,+BAA+B;AAC5D","sourcesContent":[".secondary{\n    background-color: #969da3;\n    margin-top: 5px;\n    padding: 4px 10px;\n}\n\n.tsCentered{\n    vertical-align: middle;\n}\n\n.btn-accion{\n    margin: 3px;\n    font-size: x-small;\n}\n\n.selected{\n    background-color: rgba(173, 216, 230, 0.6)!important;\n}\n.programa {\n    cursor: pointer;\n}\n.programa:hover{\n    background-color: rgba(173, 216, 230, 0.4);\n}\n\n\n\n.scrollable {\n    max-height: 50vh; /* Ajusta esta altura según tus necesidades */\n    overflow-y: scroll;\n}\n.scrollable::-webkit-scrollbar {\n    width: 8px; /* Ancho del scroll */\n}\n.scrollable::-webkit-scrollbar-thumb {\n    background-color: rgba(100, 100, 100, 0.5); /* Color del scroll */\n    border-radius: 10px; /* Redondeo del scroll */\n}\n.scrollable::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(100, 100, 100, 0.7); /* Color al pasar el cursor */\n}\n.scrollable::-webkit-scrollbar-track {\n    background: transparent; /* Fondo del track del scroll */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
